import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SbeSmsApiService, type SmsStoreEnterTokenResponseDto } from '@sbe-spinoff-client/sbe-sms-api';

@Injectable({ providedIn: 'root' })
export class SmsStoreApiService {
  private readonly api = inject(SbeSmsApiService);

  enterToken(): Promise<SmsStoreEnterTokenResponseDto> {
    return firstValueFrom(
      this.api.staffSmsStoreControllerEnterToken<SmsStoreEnterTokenResponseDto>(),
    );
  }
}
